// src/data/presets.js
export const chatStylePresets = {
    default: {
        "label": "기본",
        "fontFamily": "'CookieRun-Regular'",
        "fontWeight": 400,
        "fontUrl": "url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/CookieRun-Regular.woff') format('woff')",
        "fontSize": 28,
        "fontBold": false,
        "lineHeight": 36,
        "fontEffect": "none",
        "fontEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "shadowX": 2,
        "shadowY": 2,
        "shadowBlur": 4,
        "boxEffect": "none",
        "boxBorder": 1,
        "boxEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "boxShadowX": 2,
        "boxShadowY": 2,
        "boxShadowBlur": 4,
        "chatBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "chatTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "bodyBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 5,
        "showBadge": true, // 💡 뱃지 옵션 추가
        "userIconSize": 32,
        "badgeTop": 0,
        "stickerSize": 48,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "방송 공지가 들어갑니다.",
        "noticeFontSize": 28,
        "noticeBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "noticeHeight": 64,
        "chatRadius": 12,
        "noticeRadius": 12,
        "showNickname": true,
        "blockNickname": false,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "paddingTopBottom": 8,
        "paddingLeftRight": 13,
        "previewScale": 1,
        "nameBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "nameColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "nameColorCheck": false,
        "align": "left"
    },
    textBalloon: {
        "label": "말풍선",
        "fontFamily": "SchoolSafetyPictureDiary",
        "fontWeight": 400,
        "fontUrl": "url('https://fastly.jsdelivr.net/gh/projectnoonnu/2408-5@1.0/HakgyoansimGeurimilgiTTF-R.woff2') format('woff2')",
        "fontSize": 28,
        "fontBold": true,
        "lineHeight": 36,
        "fontEffect": "thin-outline",
        "fontEffectColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "shadowX": 2,
        "shadowY": 2,
        "shadowBlur": 4,
        "boxEffect": "none",
        "boxBorder": 1,
        "boxEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "boxShadowX": 2,
        "boxShadowY": 2,
        "boxShadowBlur": 4,
        "chatBgColor": { "r": 255, "g": 255, "b": 255, "a": 0.7 },
        "chatTextColor": { "r": 60, "g": 60, "b": 60, "a": 1 },
        "bodyBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 10,
        "showBadge": true, // 💡 뱃지 옵션 추가
        "userIconSize": 32,
        "badgeTop": 0,
        "stickerSize": 32,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "방송 공지가 들어갑니다.",
        "noticeFontSize": 28,
        "noticeBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "noticeHeight": 64,
        "chatRadius": 48,
        "noticeRadius": 12,
        "showNickname": false,
        "blockNickname": false,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "paddingTopBottom": 12,
        "paddingLeftRight": 24,
        "previewScale": 1,
        "nameBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "nameColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "nameColorCheck": false,
        "align": "center"
    },
    postIt: {
        "label": "포스트잇",
        "fontFamily": "SchoolSafeOuting",
        "fontWeight": 700,
        "fontUrl": "url('https://fastly.jsdelivr.net/gh/projectnoonnu/2408-5@1.0/HakgyoansimNadeuriTTF-B.woff2') format('woff2')",
        "fontSize": 28,
        "fontBold": false,
        "lineHeight": 36,
        "fontEffect": "shadow",
        "fontEffectColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "shadowX": 0,
        "shadowY": 0,
        "shadowBlur": 1,
        "boxEffect": "none",
        "boxBorder": 1,
        "boxEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "boxShadowX": 2,
        "boxShadowY": 2,
        "boxShadowBlur": 4,
        "chatBgColor": { "r": 255, "g": 137, "b": 163, "a": 0.8 },
        "chatTextColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "bodyBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 10,
        "showBadge": true, // 💡 뱃지 옵션 추가
        "userIconSize": 32,
        "badgeTop": 0,
        "stickerSize": 48,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "방송 공지가 들어갑니다.",
        "noticeFontSize": 28,
        "noticeBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "noticeHeight": 64,
        "chatRadius": 0,
        "noticeRadius": 12,
        "showNickname": true,
        "blockNickname": false,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "paddingTopBottom": 12,
        "paddingLeftRight": 20,
        "previewScale": 1,
        "nameBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "nameColor": { "r": 219, "g": 0, "b": 108, "a": 1 },
        "nameColorCheck": true,
        "align": "left"
    },
    square: {
        "label": "깔끔네모",
        "fontFamily": "NanumSquareNeo",
        "fontWeight": 700,
        "fontUrl": "url(https://hangeul.pstatic.net/hangeul_static/webfont/NanumSquareNeo/NanumSquareNeoTTF-cBd.woff2)",
        "fontSize": 24,
        "fontBold": true,
        "lineHeight": 36,
        "fontEffect": "none",
        "fontEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "shadowX": 2,
        "shadowY": 2,
        "shadowBlur": 4,
        "boxEffect": "shadow",
        "boxBorder": 1,
        "boxEffectColor": { "r": 0, "g": 0, "b": 0, "a": 0.6 },
        "boxShadowX": 0,
        "boxShadowY": 1,
        "boxShadowBlur": 7,
        "chatBgColor": { "r": 255, "g": 255, "b": 255, "a": 0.75 },
        "chatTextColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "bodyBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 10,
        "showBadge": true, // 💡 뱃지 옵션 추가
        "userIconSize": 32,
        "badgeTop": 0,
        "stickerSize": 36,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "방송 공지가 들어갑니다.",
        "noticeFontSize": 28,
        "noticeBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "noticeHeight": 64,
        "chatRadius": 6,
        "noticeRadius": 12,
        "showNickname": true,
        "blockNickname": true,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "paddingTopBottom": 10,
        "paddingLeftRight": 16,
        "previewScale": 1,
        "nameBgColor": { "r": 73, "g": 148, "b": 255, "a": 1 },
        "nameColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "nameColorCheck": true,
        "align": "left"
    },
    code: {
        "label": "8bit",
        "fontFamily": "RoundedFixedsys",
        "fontWeight": 400,
        "fontUrl": "url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_six@1.2/DungGeunMo.woff') format('woff')",
        "fontSize": 24,
        "fontBold": false,
        "lineHeight": 30,
        "fontEffect": "none",
        "fontEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "shadowX": 2,
        "shadowY": 2,
        "shadowBlur": 4,
        "boxEffect": "outline",
        "boxBorder": 3,
        "boxEffectColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "boxShadowX": 2,
        "boxShadowY": 2,
        "boxShadowBlur": 4,
        "chatBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.65 },
        "chatTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "bodyBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 10,
        "showBadge": true, // 💡 뱃지 옵션 추가
        "userIconSize": 32,
        "badgeTop": 0,
        "stickerSize": 32,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "방송 공지가 들어갑니다.",
        "noticeFontSize": 28,
        "noticeBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "noticeHeight": 64,
        "chatRadius": 0,
        "noticeRadius": 12,
        "showNickname": true,
        "blockNickname": false,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "paddingTopBottom": 10,
        "paddingLeftRight": 16,
        "previewScale": 1,
        "nameBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "nameColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "nameColorCheck": false,
        "align": "left"
    },
    textOnly: {
        "label": "심플매직",
        "fontFamily": "Cafe24SuperMagic",
        "fontWeight": 700,
        "fontUrl": "url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_2307-2@1.0/Cafe24Supermagic-Bold-v1.0.woff2') format('woff2')",
        "fontSize": 28,
        "fontBold": false,
        "lineHeight": 36,
        "fontEffect": "bold-outline",
        "fontEffectColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "shadowX": 2,
        "shadowY": 2,
        "shadowBlur": 4,
        "boxEffect": "none",
        "boxBorder": 1,
        "boxEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "boxShadowX": 2,
        "boxShadowY": 2,
        "boxShadowBlur": 4,
        "chatBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "chatTextColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "bodyBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 10,
        "showBadge": false, // 💡 텍스트 온리라 깔끔하게 숨김
        "userIconSize": 32,
        "badgeTop": 0,
        "stickerSize": 36,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "방송 공지가 들어갑니다.",
        "noticeFontSize": 28,
        "noticeBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "noticeHeight": 64,
        "chatRadius": 12,
        "noticeRadius": 12,
        "showNickname": false,
        "blockNickname": false,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "paddingTopBottom": 8,
        "paddingLeftRight": 13,
        "previewScale": 1,
        "nameBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "nameColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "nameColorCheck": false,
        "align": "right"
    },
    ebook: {
        "label": "E-Book",
        "fontFamily": "Ridibatang",
        "fontWeight": 400,
        "fontUrl": "url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_twelve@1.0/RIDIBatang.woff') format('woff')",
        "fontSize": 28,
        "fontBold": false,
        "lineHeight": 36,
        "fontEffect": "none",
        "fontEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "shadowX": 2,
        "shadowY": 2,
        "shadowBlur": 4,
        "boxEffect": "none",
        "boxBorder": 1,
        "boxEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "boxShadowX": 2,
        "boxShadowY": 2,
        "boxShadowBlur": 4,
        "chatBgColor": { "r": 247, "g": 245, "b": 235, "a": 0.8 },
        "chatTextColor": { "r": 70, "g": 70, "b": 70, "a": 1 },
        "bodyBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 10,
        "showBadge": true, // 💡 뱃지 옵션 추가
        "userIconSize": 32,
        "badgeTop": 0,
        "stickerSize": 48,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "방송 공지가 들어갑니다.",
        "noticeFontSize": 28,
        "noticeBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "noticeHeight": 64,
        "chatRadius": 0,
        "noticeRadius": 12,
        "showNickname": true,
        "blockNickname": true,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "paddingTopBottom": 8,
        "paddingLeftRight": 13,
        "previewScale": 1,
        "nameBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "nameColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "nameColorCheck": true,
        "align": "left"
    },
    transparent: {
        "label": "투명깔끔",
        "fontFamily": "Pretendard",
        "fontWeight": 700,
        "fontUrl": "url('https://cdn.jsdelivr.net/gh/projectnoonnu/pretendard@1.0/Pretendard-Bold.woff2') format('woff2')",
        "fontSize": 24,
        "fontBold": false,
        "lineHeight": 36,
        "fontEffect": "bold-outline",
        "fontEffectColor": { "r": 0, "g": 0, "b": 0, "a": 0.8 },
        "shadowX": 2,
        "shadowY": 2,
        "shadowBlur": 4,
        "boxEffect": "none",
        "boxBorder": 1,
        "boxEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "boxShadowX": 2,
        "boxShadowY": 2,
        "boxShadowBlur": 4,
        "chatBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "chatTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "bodyBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "enableFadeOut": true,
        "fadeDuration": 15,
        "chatMarginBottom": 6,
        "showBadge": true, // 💡 뱃지 옵션 추가
        "userIconSize": 28,
        "badgeTop": 0,
        "stickerSize": 48,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "방송 공지가 들어갑니다.",
        "noticeFontSize": 28,
        "noticeBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "noticeHeight": 64,
        "chatRadius": 0,
        "noticeRadius": 12,
        "showNickname": true,
        "blockNickname": false,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "paddingTopBottom": 4,
        "paddingLeftRight": 8,
        "previewScale": 1,
        "nameBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "nameColor": { "r": 255, "g": 234, "b": 112, "a": 1 },
        "nameColorCheck": true,
        "align": "left"
    },
    neon: {
        "label": "네온사인",
        "fontFamily": "Orbit",
        "fontWeight": 400,
        "fontUrl": "url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2310@1.0/Orbit-Regular.woff2') format('woff2')",
        "fontSize": 28,
        "fontBold": true,
        "lineHeight": 36,
        "fontEffect": "shadow",
        "fontEffectColor": { "r": 0, "g": 255, "b": 255, "a": 0.9 },
        "shadowX": 0,
        "shadowY": 0,
        "shadowBlur": 10,
        "boxEffect": "outline",
        "boxBorder": 2,
        "boxEffectColor": { "r": 255, "g": 0, "b": 204, "a": 0.7 },
        "boxShadowX": 0,
        "boxShadowY": 0,
        "boxShadowBlur": 10,
        "chatBgColor": { "r": 15, "g": 15, "b": 25, "a": 0.85 },
        "chatTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "bodyBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 10,
        "showBadge": true, // 💡 뱃지 옵션 추가
        "userIconSize": 32,
        "badgeTop": 0,
        "stickerSize": 48,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "방송 공지가 들어갑니다.",
        "noticeFontSize": 28,
        "noticeBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "noticeHeight": 64,
        "chatRadius": 8,
        "noticeRadius": 12,
        "showNickname": true,
        "blockNickname": false,
        "viewerNickname": "시청자별명",
        "letterSpacing": 1,
        "noticeTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "paddingTopBottom": 10,
        "paddingLeftRight": 16,
        "previewScale": 1,
        "nameBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "nameColor": { "r": 255, "g": 102, "b": 255, "a": 1 },
        "nameColorCheck": true,
        "align": "left"
    },
    retroConsole: {
        "label": "고전RPG",
        "fontFamily": "Galmuri11-Bold",
        "fontWeight": 700,
        "fontUrl": "url('https://cdn.jsdelivr.net/gh/projectnoonnu/2506-1@1.0/Galmuri11-Bold.woff2') format('woff2')",
        "fontSize": 24,
        "fontBold": false,
        "lineHeight": 40,
        "fontEffect": "shadow",
        "fontEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "shadowX": 2,
        "shadowY": 2,
        "shadowBlur": 0,
        "boxEffect": "outline",
        "boxBorder": 3,
        "boxEffectColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "boxShadowX": 4,
        "boxShadowY": 4,
        "boxShadowBlur": 0,
        "chatBgColor": { "r": 0, "g": 0, "b": 170, "a": 0.9 },
        "chatTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "bodyBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 8,
        "showBadge": true, // 💡 뱃지 옵션 추가
        "userIconSize": 32,
        "badgeTop": -5,
        "stickerSize": 40,
        "stickerTop": -5,
        "showNotice": false,
        "noticeText": "방송 공지가 들어갑니다.",
        "noticeFontSize": 28,
        "noticeBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "noticeHeight": 64,
        "chatRadius": 0,
        "noticeRadius": 0,
        "showNickname": true,
        "blockNickname": true,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "paddingTopBottom": 12,
        "paddingLeftRight": 20,
        "previewScale": 1,
        "nameBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.6 },
        "nameColor": { "r": 255, "g": 255, "b": 0, "a": 1 },
        "nameColorCheck": true,
        "align": "left"
    },
    pastel: {
        "label": "파스텔",
        "fontFamily": "Donggle",
        "fontWeight": 700,
        "fontUrl": "url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2108_2@1.0/Dongle-Bold.woff') format('woff')",
        "fontSize": 34,
        "fontBold": false,
        "lineHeight": 40,
        "fontEffect": "none",
        "fontEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "shadowX": 2,
        "shadowY": 2,
        "shadowBlur": 4,
        "boxEffect": "none",
        "boxBorder": 1,
        "boxEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "boxShadowX": 0,
        "boxShadowY": 4,
        "boxShadowBlur": 10,
        "chatBgColor": { "r": 255, "g": 240, "b": 245, "a": 0.9 },
        "chatTextColor": { "r": 90, "g": 70, "b": 70, "a": 1 },
        "bodyBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 12,
        "showBadge": true, // 💡 뱃지 옵션 추가
        "userIconSize": 36,
        "badgeTop": 0,
        "stickerSize": 40,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "방송 공지가 들어갑니다.",
        "noticeFontSize": 28,
        "noticeBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "noticeHeight": 64,
        "chatRadius": 20,
        "noticeRadius": 12,
        "showNickname": true,
        "blockNickname": false,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "paddingTopBottom": 14,
        "paddingLeftRight": 20,
        "previewScale": 1,
        "nameBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "nameColor": { "r": 230, "g": 120, "b": 150, "a": 1 },
        "nameColorCheck": true,
        "align": "left"
    },

    // ✨ 여기서부터 새롭게 추가된 프리셋 5종입니다 ✨

    cyberpunk: {
        "label": "사이버펑크",
        "fontFamily": "Monoplexkr",
        "fontWeight": 700,
        "fontUrl": "url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_Monoplex-kr@1.0/MonoplexKR-Bold.woff2') format('woff2')",
        "fontSize": 26,
        "fontBold": true,
        "lineHeight": 32,
        "fontEffect": "shadow",
        "fontEffectColor": { "r": 0, "g": 255, "b": 100, "a": 0.7 },
        "shadowX": 0,
        "shadowY": 0,
        "shadowBlur": 6,
        "boxEffect": "outline",
        "boxBorder": 1,
        "boxEffectColor": { "r": 0, "g": 255, "b": 100, "a": 0.5 },
        "boxShadowX": 0,
        "boxShadowY": 0,
        "boxShadowBlur": 0,
        "chatBgColor": { "r": 10, "g": 10, "b": 10, "a": 0.8 },
        "chatTextColor": { "r": 200, "g": 255, "b": 200, "a": 1 },
        "bodyBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 6,
        "showBadge": false, // 컨셉에 맞게 뱃지 가리기
        "userIconSize": 28,
        "badgeTop": 0,
        "stickerSize": 36,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "SYSTEM_NOTICE:",
        "noticeFontSize": 28,
        "noticeBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.5 },
        "noticeHeight": 64,
        "chatRadius": 0,
        "noticeRadius": 0,
        "showNickname": true,
        "blockNickname": true,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 0, "g": 255, "b": 100, "a": 1 },
        "paddingTopBottom": 8,
        "paddingLeftRight": 14,
        "previewScale": 1,
        "nameBgColor": { "r": 0, "g": 255, "b": 100, "a": 0.1 },
        "nameColor": { "r": 0, "g": 255, "b": 100, "a": 1 },
        "nameColorCheck": true,
        "align": "left"
    },
    cloud: {
        "label": "구름둥둥",
        "fontFamily": "GowoonDodum",
        "fontWeight": 400,
        "fontUrl": "url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2108@1.1/GowunDodum-Regular.woff') format('woff')",
        "fontSize": 24,
        "fontBold": false,
        "lineHeight": 34,
        "fontEffect": "none",
        "fontEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "shadowX": 0,
        "shadowY": 0,
        "shadowBlur": 0,
        "boxEffect": "shadow",
        "boxBorder": 0,
        "boxEffectColor": { "r": 150, "g": 200, "b": 255, "a": 0.3 },
        "boxShadowX": 0,
        "boxShadowY": 4,
        "boxShadowBlur": 12,
        "chatBgColor": { "r": 255, "g": 255, "b": 255, "a": 0.95 },
        "chatTextColor": { "r": 80, "g": 110, "b": 150, "a": 1 },
        "bodyBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 12,
        "showBadge": true,
        "userIconSize": 32,
        "badgeTop": -2,
        "stickerSize": 40,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "오늘의 공지사항 ☁️",
        "noticeFontSize": 26,
        "noticeBgColor": { "r": 255, "g": 255, "b": 255, "a": 0.8 },
        "noticeHeight": 60,
        "chatRadius": 30,
        "noticeRadius": 30,
        "showNickname": true,
        "blockNickname": false,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 100, "g": 150, "b": 255, "a": 1 },
        "paddingTopBottom": 12,
        "paddingLeftRight": 22,
        "previewScale": 1,
        "nameBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "nameColor": { "r": 100, "g": 150, "b": 255, "a": 1 },
        "nameColorCheck": true,
        "align": "left"
    },
    typewriter: {
        "label": "감성타자기",
        "fontFamily": "GounBatang",
        "fontWeight": 400,
        "fontUrl": "url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2108@1.1/GowunBatang-Regular.woff') format('woff')",
        "fontSize": 24,
        "fontBold": false,
        "lineHeight": 36,
        "fontEffect": "none",
        "fontEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "shadowX": 0,
        "shadowY": 0,
        "shadowBlur": 0,
        "boxEffect": "shadow",
        "boxBorder": 0,
        "boxEffectColor": { "r": 0, "g": 0, "b": 0, "a": 0.1 },
        "boxShadowX": 1,
        "boxShadowY": 1,
        "boxShadowBlur": 3,
        "chatBgColor": { "r": 245, "g": 242, "b": 235, "a": 0.95 },
        "chatTextColor": { "r": 60, "g": 55, "b": 50, "a": 1 },
        "bodyBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 10,
        "showBadge": true,
        "userIconSize": 28,
        "badgeTop": -4,
        "stickerSize": 40,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "안내 말씀 드립니다.",
        "noticeFontSize": 24,
        "noticeBgColor": { "r": 230, "g": 225, "b": 215, "a": 0.9 },
        "noticeHeight": 56,
        "chatRadius": 4,
        "noticeRadius": 4,
        "showNickname": true,
        "blockNickname": true,
        "viewerNickname": "시청자별명",
        "letterSpacing": -0.5,
        "noticeTextColor": { "r": 50, "g": 50, "b": 50, "a": 1 },
        "paddingTopBottom": 14,
        "paddingLeftRight": 20,
        "previewScale": 1,
        "nameBgColor": { "r": 245, "g": 242, "b": 235, "a": 0 },
        "nameColor": { "r": 130, "g": 60, "b": 50, "a": 1 },
        "nameColorCheck": true,
        "align": "left"
    },
    popArt: {
        "label": "팝아트",
        "fontFamily": "Black Han Sans",
        "fontWeight": 400,
        "fontUrl": "url('https://fonts.googleapis.com/css?family=Black+Han+Sans:400')",
        "fontSize": 32,
        "fontBold": false,
        "lineHeight": 38,
        "fontEffect": "bold-outline",
        "fontEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "shadowX": 0,
        "shadowY": 0,
        "shadowBlur": 0,
        "boxEffect": "shadow",
        "boxBorder": 0,
        "boxEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "boxShadowX": 4,
        "boxShadowY": 4,
        "boxShadowBlur": 0,
        "chatBgColor": { "r": 255, "g": 230, "b": 0, "a": 1 },
        "chatTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "bodyBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "enableFadeOut": false,
        "fadeDuration": 30,
        "chatMarginBottom": 10,
        "showBadge": true,
        "userIconSize": 36,
        "badgeTop": -2,
        "stickerSize": 48,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "POP NOTICE!",
        "noticeFontSize": 34,
        "noticeBgColor": { "r": 255, "g": 0, "b": 100, "a": 1 },
        "noticeHeight": 70,
        "chatRadius": 0,
        "noticeRadius": 0,
        "showNickname": true,
        "blockNickname": true,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 255, "g": 255, "b": 255, "a": 1 },
        "paddingTopBottom": 10,
        "paddingLeftRight": 18,
        "previewScale": 1,
        "nameBgColor": { "r": 255, "g": 255, "b": 255, "a": 0 },
        "nameColor": { "r": 255, "g": 0, "b": 100, "a": 1 },
        "nameColorCheck": true,
        "align": "center"
    },
    modernDark: {
        "label": "모던다크",
        "fontFamily": "Pretendard",
        "fontWeight": 500,
        "fontUrl": "url('https://cdn.jsdelivr.net/gh/projectnoonnu/pretendard@1.0/Pretendard-Medium.woff2') format('woff2')",
        "fontSize": 24,
        "fontBold": false,
        "lineHeight": 34,
        "fontEffect": "none",
        "fontEffectColor": { "r": 0, "g": 0, "b": 0, "a": 1 },
        "shadowX": 0,
        "shadowY": 0,
        "shadowBlur": 0,
        "boxEffect": "outline",
        "boxBorder": 1,
        "boxEffectColor": { "r": 80, "g": 80, "b": 90, "a": 0.6 },
        "boxShadowX": 0,
        "boxShadowY": 0,
        "boxShadowBlur": 0,
        "chatBgColor": { "r": 30, "g": 30, "b": 35, "a": 0.85 },
        "chatTextColor": { "r": 230, "g": 230, "b": 235, "a": 1 },
        "bodyBgColor": { "r": 0, "g": 0, "b": 0, "a": 0 },
        "enableFadeOut": true,
        "fadeDuration": 15,
        "chatMarginBottom": 8,
        "showBadge": true,
        "userIconSize": 28,
        "badgeTop": -1,
        "stickerSize": 36,
        "stickerTop": 0,
        "showNotice": false,
        "noticeText": "Notice Here",
        "noticeFontSize": 24,
        "noticeBgColor": { "r": 40, "g": 40, "b": 45, "a": 0.9 },
        "noticeHeight": 56,
        "chatRadius": 16,
        "noticeRadius": 16,
        "showNickname": true,
        "blockNickname": true,
        "viewerNickname": "시청자별명",
        "letterSpacing": 0,
        "noticeTextColor": { "r": 180, "g": 180, "b": 190, "a": 1 },
        "paddingTopBottom": 12,
        "paddingLeftRight": 18,
        "previewScale": 1,
        "nameBgColor": { "r": 0, "g": 0, "b": 0, "a": 0.2 },
        "nameColor": { "r": 150, "g": 150, "b": 170, "a": 1 },
        "nameColorCheck": true,
        "align": "left"
    }
};